// angular
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';

// services
import {
  ApiService,
  AuthService,
  CacheService,
  ConfigService,
  InvestorService,
  NotaryService,
  OrganizationService,
  TradeService,
  UserService,
} from '@core/services';

// guards
import { AuthGuard, InitiateGuard, NoAuthGuard, RoleRedirectGuard } from '@core/guards';

// interceptors
import { AuthInterceptor, ErrorInterceptor } from '@core/interceptors';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [],
  exports: [
    BrowserModule
  ]
})
export class CoreModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: [
        // services
        ApiService,
        CacheService,
        ConfigService,
        UserService,
        TradeService,
        AuthService,
        NotaryService,
        OrganizationService,
        InvestorService,

        // guards
        AuthGuard,
        NoAuthGuard,
        RoleRedirectGuard,
        InitiateGuard,

        // interceptors
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthInterceptor,
          multi: true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ErrorInterceptor,
          multi: true
        }
      ]
    };
  }
}
